import './styles.css';

import React, { useState } from 'react';
import defaultImage from 'assets/img/default-course-img.png';
import { getCdnUrl, appPostMessage } from 'utils';
import { IShow } from 'interface/cast';
import EpisodeItem from './EpisodeItem';

interface IProps {
  show: IShow;
}

const ShowShelf = ({ show }: IProps) => {
  const [img, setImg] = useState(getCdnUrl(show?.coverUrl, defaultImage));

  const handleImgError = () => {
    setImg(defaultImage);
  };

  const handleClick = () => {
    appPostMessage('navigate-to-show', { show });
  };

  return (
    <div className='nc-shelf'>
      <span role='button' className='nc-shelf-header' onClick={handleClick}>
        <img src={img} alt={`Cast ${show?.title}`} onError={handleImgError} />
        <div className='nc-shelf-header-info'>
          <label className='nc-shelf-title'>{show?.title}</label>
          <label className='nc-shelf-author'>{show?.author?.name}</label>
        </div>
      </span>
      <hr />
      <div className='nc-shelf-episodes'>
        {show?.episodes?.map((episode) => (
          <EpisodeItem key={episode.id} episode={episode} />
        ))}
      </div>
    </div>
  );
};

export default ShowShelf;
